/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roadmap_CopyInputs */

const en_roadmap_copy = /** @type {(inputs: Roadmap_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy as ROADMAP.md`)
};

const de_roadmap_copy = /** @type {(inputs: Roadmap_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als ROADMAP.md kopieren`)
};

/**
* | output |
* | --- |
* | "Copy as ROADMAP.md" |
*
* @param {Roadmap_CopyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const roadmap_copy = /** @type {((inputs?: Roadmap_CopyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roadmap_CopyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_roadmap_copy(inputs)
	return en_roadmap_copy(inputs)
});